import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d5d8a56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "other-result-intermiadiate" }
const _hoisted_2 = {
  key: 0,
  class: "row justify-content-center p-5"
}
const _hoisted_3 = {
  key: 1,
  class: "p-5 pb-4"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex my-3"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-info-circle" }, null, -1))
const _hoisted_6 = { class: "ms-4 col" }
const _hoisted_7 = { class: "fs-7 fw-bold text-uppercase" }
const _hoisted_8 = {
  key: 2,
  class: "col d-flex mt-3"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-paperclip" }, null, -1))
const _hoisted_10 = { class: "ms-4" }
const _hoisted_11 = { class: "fs-7 fw-bold text-uppercase" }
const _hoisted_12 = { class: "d-flex mt-3" }
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-file-pdf-fill" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 3,
  class: "col mt-4"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-stickies" }, null, -1))
const _hoisted_18 = { class: "fs-7 ms-4 fw-bold text-uppercase" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 4,
  class: "container justify-content-center text-center ps-0 pe-0",
  style: {"opacity":"0.7"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_MrUiKitBlob = _resolveComponent("MrUiKitBlob")!
  const _component_IntermiadiateBlock = _resolveComponent("IntermiadiateBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Spinner)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.showBlob)
            ? (_openBlock(), _createBlock(_component_MrUiKitBlob, {
                key: 0,
                files: _ctx.blobFiles,
                onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showBlob = false))
              }, null, 8, ["files"]))
            : _createCommentVNode("", true),
          (_ctx.intermiadiates.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.t("result.intermiadiate")), 1),
                  _createVNode(_component_IntermiadiateBlock, { items: _ctx.intermiadiates }, null, 8, ["items"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.attachments.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.t("result.attachments")), 1),
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (a, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: 'attachment-' + index
                      }, [
                        (!_ctx.isPdf(a.url))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: _normalizeClass(["avatar-initials", index !== 0 && 'ms-3']),
                              style: {"width":"60px","height":"60px"},
                              src: a.url
                            }, null, 10, _hoisted_13))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass([index !== 0 && 'ms-3', "icon icon-soft-danger"]),
                              style: {"width":"60px","height":"60px"}
                            }, _hoisted_15, 2))
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.generalNotes)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("common.notes")), 1),
                _createElementVNode("div", {
                  class: "ms-6 mt-4",
                  innerHTML: _ctx.generalNotes
                }, null, 8, _hoisted_19)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.intermiadiates.length && !_ctx.attachments.length && !_ctx.generalNotes)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.t("common.noResults")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}